import { apiService } from "@/services/apiService";
import { endpoints } from "@/config/endpoints";

export default {
  getReportExportStatus(exportId) {
    return apiService.get(endpoints.reportExportStatus(exportId));
  },

  getReportExportDownload(exportId) {
    return apiService.get(endpoints.reportExportDownload(exportId), {
      responseType: "blob"
    });
  }
};
